import { FormControl, styled } from '@mui/material';

export const FormControlStyled = styled(FormControl, {
  shouldForwardProp: (prop) => prop !== 'isHidden' && prop !== 'filesPage',
})(({ theme, isHidden, filesPage }) => ({
  display: isHidden && 'none',
  width: '100%',

  '& .MuiFormControl-root': {
    marginTop: 0,
  },

  '& .MuiFormControlLabel-root': {
    width: '150px',
    height: '32px',
    padding: '0 9px',
    backgroundColor: theme.palette.colors.secondaryBackground,

    '& .MuiSvgIcon-root': {
      width: '14px',
      height: '14px',
    },
  },

  [theme.breakpoints.up('md')]: {
    '& .MuiFormControlLabel-root': {
      width: '216px',
    },
  },
  [theme.breakpoints.up('lg')]: {
    '& .MuiFormControlLabel-root': {
      width: '163px',
    },
  },
  [theme.breakpoints.up('xxl')]: {
    width: !filesPage && '288px',

    '& .MuiFormControlLabel-root': {
      width: '140px',
    },
  },
}));
